
import React, { Component } from 'react';
import { FormControl, Select, MenuItem, InputLabel} from '@material-ui/core'



class Height extends Component{
    constructor(props){
        super(props)
        this.state = {
            invalidAnswer: true, //on ComponenetDidMount, put logic in to update htis based on response
            answer: "",
            answerInches: -1,
            answerFeet: -1,
            valMin: "",
            valMax: "",
            valPrecision: "",
            errorMessage: "",
            inputError: false,
            Inches:  [0,1,2,3,4,5,6,7,8,9,10,11],
            Feet: [0,1,2,3,4,5,6,7,8,9]
        }
    }

    
    componentDidMount() {
        //gotta convert to int for all the math stuff
        //important for comparisons ( >0 vs .length)
        var answer = parseInt(this.props.question.Responses[0].Response)
        this.createFeetArray()
        this.setState({
            answer: answer,
            invalidAnswer: true,
            valMin: this.props.question.ValueLimitationMin,
            valMax: this.props.question.ValueLimitationMax,
            valPrecision: this.props.question.ValueLimitationPrecision,
            errorMessage:"" 
        })
        if(this.props.question.Responses[0].Response > 0 ){
            this.setInchesAndFeet(this.props.question.Responses[0].Response)
        }
    }

    createFeetArray(){
        let max = Math.floor(this.props.question.ValueLimitationMax/12)
        let min = Math.floor(this.props.question.ValueLimitationMin/12)

        let feet = []

        for(var x=min; x<max+1; x++){
            feet.push(x)
        }

        this.setState({
            Feet:feet
        })
        
        console.log(feet)
    }

    setInchesAndFeet(answer){
        var feet = Math.floor(answer/12)
        var inches = answer % 12

        this.setState({
            answerInches: inches,
            answerFeet: feet
        })
        
    }

    setInches = ev => {
        this.setState({
            answerInches: ev.target.value
        }, () =>  {
            if(this.state.answerFeet >= 0 && this.state.answerInches >= 0){
                this.setSavableAnswer()
            }
        })
    }

    setFeet = ev => {
        this.setState({
            answerFeet: ev.target.value
        }, () =>  {
                if(this.state.answerFeet >= 0 && this.state.answerInches >= 0){
                    this.setSavableAnswer()
                }
            }    
        )
    }

    setSavableAnswer(){
        var inches = this.state.answerInches + this.state.answerFeet*12
        if(inches > this.state.valMax || inches<this.state.valMin){
            this.setState({
                errorMessage: this.props.validation.HeightOutOfRange,
                invalidAnswer:true
            })
        } else {
            if(inches > 0){
                var inchString = inches.toString()
                this.props.updateResponseValue(inchString)
            }
        }
    }

    render(){
        if(this.props){
            let answer = this.props.question.Responses[0].Response;
            
            return(
                //<Radio>Answer</Radio>
                <div style={{width:'100%', textAlign:'center'}}>
                    <FormControl variant="outlined" style={{minWidth:'100px',
                        margin:'10px',
                        padding:'10px'}}>
                                <InputLabel id='feet-label'>{this.props.prompts.HeightPrimary}</InputLabel>
                                <Select
                                  labelId="feet-label"
                                  value={this.state.answerFeet}
                                  onChange={this.setFeet}
                                  label="Feet"
                                >
                                {this.state.Feet.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                </Select>
                    </FormControl>
                    <FormControl variant="outlined" style={{minWidth:'100px',
                            margin:'10px',
                            padding:'10px'}}>
                                <InputLabel id="select-outlined-label">{this.props.prompts.HeightSecondary}</InputLabel>
                                <Select
                                  labelId="select-outlined-label"
                                  id="select-outlined"
                                  value={this.state.answerInches}
                                  onChange={this.setInches}
                                  label="Inches"
                                >
                                {this.state.Inches.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                </Select>
                    </FormControl>
                    <p style={{color:"red"}}>{this.state.errorMessage}</p>
                </div>
                
            )
        }
        
    }
}

export default Height;